/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { getIn, useFormik } from 'formik';
const usePeFormik = (props) => {
    const formik = useFormik({ ...props });
    const requiredFields = Object.keys(formik.values).reduce((fields, name) => {
        const fieldValidationSchema = props.validationSchema
            ? getIn(props.validationSchema.describe().fields, name)
            : false;
        const tests = fieldValidationSchema ? fieldValidationSchema.tests : false;
        const isRequired = tests
            ? !!tests.some((test) => test.name === 'required')
            : false;
        return { ...fields, [name]: isRequired };
    }, formik.values);
    return { ...formik, requiredFields };
};
export default usePeFormik;
